export enum ServiceCategory {
    All = 0,
    PersonLicence = 1,
    DayCareCenter = 2
}
